import React from 'react';
import injectSheet from 'react-jss';
import Text from '../components/Text';
import ConnectBanner from '../components/banner/ConnectBanner';

const ErrorPage = ({classes, history, ...rest}) => {
    const images = [
        'https://cdn.streamelements.com/static/KappaKingGifSmall.gif',
        'https://cdn.streamelements.com/static/bbona.png',
    ];
    const image = images[Math.floor(Math.random() * images.length)];
    return (
        <div className={`${classes.chatStats} ${classes.layoutColumnXs}`}>
            <ConnectBanner/>
            <div className={classes.notfoundWrapper}>
                <img src={image} height="124" alt="BBona" className={classes.notfoundImage} />
                <Text type="text" classList={[classes.notfoundText]}>404 - Page Not Found</Text>
            </div>
        </div>
    );
};

const styles = theme => {
    return ({
        chatStats: {
            maxWidth: theme.pages.maxWidth,
            margin: '0 auto',
            backgroundColor: theme.backgrounds.page,
            paddingBottom: theme.spacing * 4,
            paddingLeft: theme.spacing * 3,
            paddingRight: theme.spacing * 3,
        },
        layoutColumnXs: {
            [theme.devices.small]: {
                display: 'flex',
                flexDirection: 'column'
            }
        },
        notfoundWrapper: {
            textAlign: 'center',
            marginTop: 97,
        },
        notfoundText: {
            fontSize: 28,
        },
        notfoundImage: {
            display: 'block',
            margin: 'auto',
            marginBottom: 24,
        },
    })
};

export default injectSheet(styles)(ErrorPage);



// WEBPACK FOOTER //
// ./src/app/pages/Errorpage.jsx